import { render, staticRenderFns } from "./CharacterCount.vue?vue&type=template&id=1c98c416&"
import script from "./CharacterCount.vue?vue&type=script&lang=ts&"
export * from "./CharacterCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports